import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@components/button';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';
import { UserAddressBottomsheetComponent } from './user-address-bottomsheet.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    ButtonCtaComponent,
  ],
  declarations: [UserAddressBottomsheetComponent],
  exports: [UserAddressBottomsheetComponent],
})
export class UserAddressBottomsheetModule {}
